var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncrease31Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5521 9.29843C44.988 9.81406 44.1125 9.77253 43.5968 9.20845L39.9978 5.26681V37.589C39.9978 38.5441 39.2226 39.3193 38.2675 39.3193H19.3068C18.3516 39.3193 17.5765 38.5441 17.5765 37.589V26.643H3.46062V43.1017C3.46062 44.0569 2.68544 44.832 1.73031 44.832C0.775178 44.832 0 44.0569 0 43.1017V24.9127C0 23.9576 0.775178 23.1824 1.73031 23.1824H19.3068C20.2619 23.1824 21.0371 23.9576 21.0371 24.9127V35.8587H36.5406V4.98996L32.2599 9.05619C31.7062 9.5822 30.8306 9.56144 30.3011 9.00774C29.7751 8.45404 29.7959 7.5785 30.3496 7.05249L36.686 1.03102C36.9559 0.421951 37.5615 -0.000244141 38.2675 -0.000244141C38.2813 -0.000244141 38.2917 -0.000240326 38.3021 0.0032196C38.309 0.0032196 38.3159 0.0032196 38.3229 0.0032196C38.4163 0.0032196 38.5097 0.0135956 38.5997 0.030899C38.6274 0.0378189 38.6551 0.0482063 38.6828 0.0551262C38.7451 0.0724297 38.8073 0.0862732 38.8662 0.113956C39.278 0.266224 39.6137 0.570759 39.8075 0.961807L45.6386 7.34664C46.1542 7.91072 46.1127 8.78626 45.5486 9.30189L45.5521 9.29843Z",
    fill: "#F3A890"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease31Plus);
export default __webpack_public_path__ + "static/media/increase31plus.7c344c0cea49614064bbd72e1f39a370.svg";
export { ForwardRef as ReactComponent };